import { z } from 'zod';

import { ExternalAccountTimingToCreate } from '@/common/graphql';

export const EmployeeExternalAccountFormData = z.object({
  autoCreationSettings: z
    .object({
      googleWorkspace: z.boolean(),
      greenhouse: z.boolean(),
    })
    .default({
      googleWorkspace: false,
      greenhouse: false,
    }),
  timingToCreate: z.nativeEnum(ExternalAccountTimingToCreate).default(ExternalAccountTimingToCreate.None),
});
